export namespace StarWars {
	export enum Type {
		skywalkerSagaFilm = "Skywalker Saga",
		film = "Film",
		show = "Show",
		game = "Game",
		book = "Novel",
		youngAdultNovel = "Young Adult Novel",
		juniorReader = "Junior Reader",
		audioDrama = "Audio Drama",
	}

	// https://www.starwars.com/eras
	export enum Era {
		dawnOfTheJedi = "Dawn of the Jedi",
		oldRepublic = "The Old Republic",
		highRepublic = "The High Republic",
		republic = "Fall of the Jedi",
		empire = "Reign of the Empire",
		rebellion = "Age of Rebellion",
		newRepublic = "The New Republic",
		firstOrder = "Rise of the First Order",
		newJediOrder = "New Jedi Order",
	}

	export interface MediaLink {
		iconClass: string
		tooltipText: string
	}

	export interface Entry {
		name: string
		type: Type
		era: Era
		mediaLink: string | null
		wookieepedia: string
		released: Date | null
		timeline: number
	}

	export function formatTimeline(timelineArg: number): string {
		let timeline = timelineArg
		if (timeline < 1 && timeline > -1) {
			timeline = 0
		}

		if (timeline < 0) {
			return `BBY ${Math.ceil(timeline) * -1}`
		}

		if (timeline > 0) {
			return `${Math.floor(timeline)} ABY`
		}

		return "BBY 0 / 0 ABY"
	}

	export function getMediaLink(mediaLink: string): MediaLink {
		if (mediaLink.includes("disneyplus.com")) {
			return {
				iconClass: "fa-solid fa-tv",
				tooltipText: "Watch on Disney+",
			}
		}

		if (mediaLink.includes("xbox.com")) {
			return {
				iconClass: "fa-brands fa-xbox",
				tooltipText: "Play on Xbox",
			}
		}

		if (mediaLink.includes("meta.com")) {
			return {
				iconClass: "fa-solid fa-vr-cardboard",
				tooltipText: "Play on Meta Quest",
			}
		}

		if (mediaLink.includes("audible.com")) {
			return {
				iconClass: "fa-brands fa-audible",
				tooltipText: "Listen on Audible",
			}
		}

		if (mediaLink.includes("amazon.com")) {
			return {
				iconClass: "fa-brands fa-amazon",
				tooltipText: "Read on Amazon",
			}
		}

		throw `Unmapped Media Link: ${mediaLink}`
	}

	// TODO: add tales of the jedi
	// TODO: add tales of the empire

	const skywalkerSaga: Entry[] = [
		{
			era: Era.republic,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-the-phantom-menace-episode-i/2ezYynkgW1AH",
			name: "The Phantom Menace",
			released: new Date("1999-05-19 10:00:00Z"),
			timeline: -32,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_I_The_Phantom_Menace",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-attack-of-the-clones-episode-ii/mgpYHGnzZW6N",
			name: "Attack of the Clones",
			released: new Date("2002-05-16 10:00:00Z"),
			timeline: -22.9,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_II_Attack_of_the_Clones",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-revenge-of-the-sith-episode-iii/4WvbqLFumNvi",
			name: "Revenge of the Sith",
			released: new Date("2005-05-19 10:00:00Z"),
			timeline: -19.5,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_III_Revenge_of_the_Sith",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-a-new-hope-episode-iv/12fVeZxD2fWJ",
			name: "A New Hope",
			released: new Date("1977-05-25 10:00:00Z"),
			timeline: 0,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_IV_A_New_Hope",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-the-empire-strikes-back-episode-v/iqtDTZAewwYl",
			name: "The Empire Strikes Back",
			released: new Date("1980-05-12 10:00:00Z"),
			timeline: 3,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_V_The_Empire_Strikes_Back",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-return-of-the-jedi-episode-vi/6QGKo5mjDBS8",
			name: "Return of the Jedi",
			released: new Date("1983-05-25 10:00:00Z"),
			timeline: 4,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_VI_Return_of_the_Jedi",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-the-force-awakens-episode-vii/1LEKJPDPeMr7",
			name: "The Force Awakens",
			released: new Date("2015-12-18 10:00:00Z"),
			timeline: 34.1,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_VII_The_Force_Awakens",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-the-last-jedi-episode-viii/1nCWFK1pmAI0",
			name: "The Last Jedi",
			released: new Date("2017-12-15 10:00:00Z"),
			timeline: 34.11,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_VIII_The_Last_Jedi",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-the-rise-of-skywalker-episode-ix/5e8JThYwCYgw",
			name: "The Rise of Skywalker",
			released: new Date("2019-12-20 10:00:00Z"),
			timeline: 35,
			type: Type.skywalkerSagaFilm,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Episode_IX_The_Rise_of_Skywalker",
		},
	]

	const otherFilms: Entry[] = [
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/movies/rogue-one-a-star-wars-story/14CV6eSbygOA",
			name: "Rogue One",
			released: new Date("2016-12-15 10:00:00Z"),
			timeline: -0.5,
			type: Type.film,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Rogue_One:_A_Star_Wars_Story",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/movies/solo-a-star-wars-story/7ks3IYr1eU2P",
			name: "Solo",
			released: new Date("2018-05-25 10:00:00Z"),
			timeline: -10,
			type: Type.film,
			wookieepedia: "https://starwars.fandom.com/wiki/Solo:_A_Star_Wars_Story",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.disneyplus.com/movies/star-wars-the-clone-wars/AVmv1ulT1nQW",
			name: "The Clone Wars (Movie)",
			released: new Date("2008-08-14 10:00:00Z"),
			timeline: -22.7,
			type: Type.film,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_The_Clone_Wars_(film)",
		},
		{
			era: Era.newJediOrder,
			mediaLink: null,
			name: "Starfighter",
			released: new Date("2027-05-28 10:00:00Z"),
			timeline: 40,
			type: Type.film,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars:_Starfighter",
		},
		{
			era: Era.newRepublic,
			mediaLink: null,
			name: "The Mandalorian & Grogu",
			released: new Date("2026-05-22 10:00:00Z"),
			timeline: 12.3,
			type: Type.film,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_Mandalorian_and_Grogu",
		},
	]

	const shows: Entry[] = [
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.disneyplus.com/series/the-mandalorian/3jLIGMDYINqD",
			name: "The Mandalorian S01",
			released: new Date("2019-11-12 10:00:00Z"),
			timeline: 9,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/The_Mandalorian",
		},
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.disneyplus.com/series/the-mandalorian/3jLIGMDYINqD",
			name: "The Mandalorian S02",
			released: new Date("2020-10-30 10:00:00Z"),
			timeline: 10,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/The_Mandalorian",
		},
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.disneyplus.com/series/the-mandalorian/3jLIGMDYINqD",
			name: "The Mandalorian S03",
			released: new Date("2023-03-01 10:00:00Z"),
			timeline: 12,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/The_Mandalorian",
		},
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.disneyplus.com/series/the-book-of-boba-fett/57TL7zLNu2wf",
			name: "The Book of Boba Fett",
			released: new Date("2021-12-29 10:00:00Z"),
			timeline: 10.1,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/The_Book_of_Boba_Fett",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/obi-wan-kenobi/2JYKcHv9fRJb",
			name: "Obi-Wan Kenobi",
			released: new Date("2022-05-27 10:00:00Z"),
			timeline: -9.5,
			type: Type.show,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Obi-Wan_Kenobi_(television_series)",
		},
		{
			era: Era.empire,
			mediaLink: "https://www.disneyplus.com/series/andor/3xsQKWG00GL5",
			name: "Andor S01",
			released: new Date("2022-09-21 10:00:00Z"),
			timeline: -5.1,
			type: Type.show,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Andor_(television_series)",
		},
		{
			era: Era.empire,
			mediaLink: "https://www.disneyplus.com/series/andor/3xsQKWG00GL5",
			name: "Andor S02",
			released: new Date("2025-04-22 10:00:00Z"),
			timeline: -4.1,
			type: Type.show,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Andor_(television_series)",
		},
		{
			era: Era.newRepublic,
			mediaLink: null,
			name: "Ahsoka",
			released: new Date("2023-08-23 10:00:00Z"),
			timeline: 12.1,
			type: Type.show,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Ahsoka_(television_series)",
		},
		{
			era: Era.newRepublic,
			mediaLink: null,
			name: "Skeleton Crew",
			released: new Date("2024-12-02 10:00:00Z"),
			timeline: 12.2,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars:_Skeleton_Crew",
		},
		{
			era: Era.highRepublic,
			mediaLink: null,
			name: "The Acolyte",
			released: new Date("2024-06-04 10:10:00Z"),
			timeline: -132,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/The_Acolyte",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-the-clone-wars/1wYXzjabXGVZ",
			name: "The Clone Wars",
			released: new Date("2008-10-03 10:00:00Z"),
			timeline: -22.55,
			type: Type.show,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_The_Clone_Wars",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-rebels/64MCZgAzY0Zw",
			name: "Rebels S01",
			released: new Date("2014-10-03 10:00:00Z"),
			timeline: -5,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Rebels",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-rebels/64MCZgAzY0Zw",
			name: "Rebels S02",
			released: new Date("2015-06-20 10:00:00Z"),
			timeline: -4,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Rebels",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-rebels/64MCZgAzY0Zw",
			name: "Rebels S03",
			released: new Date("2016-09-24 10:00:00Z"),
			timeline: -2.1,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Rebels",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-resistance/FQwsUthRSbnp",
			name: "Resistance S01",
			released: new Date("2018-10-07 10:00:00Z"),
			timeline: 34,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Resistance",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-resistance/FQwsUthRSbnp",
			name: "Resistance S02",
			released: new Date("2019-10-06 10:00:00Z"),
			timeline: 34.2,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Resistance",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-the-bad-batch/4gMliqFxxqXC",
			name: "The Bad Batch S01",
			released: new Date("2021-05-04 10:00:00Z"),
			timeline: -19.45,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars:_The_Bad_Batch",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-the-bad-batch/4gMliqFxxqXC",
			name: "The Bad Batch S02",
			released: new Date("2023-01-04 10:00:00Z"),
			timeline: -17,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars:_The_Bad_Batch",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.disneyplus.com/series/star-wars-the-bad-batch/4gMliqFxxqXC",
			name: "The Bad Batch S03",
			released: new Date("2024-02-21 10:00:00Z"),
			timeline: -15,
			type: Type.show,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars:_The_Bad_Batch",
		},
		{
			era: Era.empire,
			mediaLink: null,
			name: "Maul - Shadow Lord",
			released: null,
			timeline: -18.6,
			type: Type.show,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Maul_-_Shadow_Lord",
		},
	]

	const games: Entry[] = [
		{
			era: Era.empire,
			mediaLink: "https://www.xbox.com/en-US/games/star-wars-jedi-fallen-order",
			name: "Jedi: Fallen Order",
			released: new Date("2019-11-15 10:00:00Z"),
			timeline: -14,
			type: Type.game,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars_Jedi:_Fallen_Order",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.xbox.com/en-US/games/store/star-wars-jedi-survivor-standard-edition/9NJXPV1WX44X/0017",
			name: "Jedi: Survivor",
			released: new Date("2023-04-28 10:00:00Z"),
			timeline: -9,
			type: Type.game,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Jedi:_Survivor",
		},
		{
			era: Era.rebellion,
			mediaLink: null,
			name: "Outlaws",
			released: new Date("2024-08-30 10:00:00Z"),
			timeline: 3.5,
			type: Type.game,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Outlaws",
		},
		{
			era: Era.rebellion,
			mediaLink: "https://www.xbox.com/en-US/games/star-wars-squadrons",
			name: "Squadrons",
			released: new Date("2020-10-02 10:00:00Z"),
			timeline: 4.9,
			type: Type.game,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars:_Squadrons",
		},
		{
			era: Era.rebellion,
			mediaLink: "https://www.xbox.com/en-US/games/star-wars-battlefront-ii",
			name: "Battlefront II",
			released: new Date("2017-11-09 10:00:00Z"),
			timeline: 4.5,
			type: Type.game,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Battlefront_II",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.meta.com/experiences/vader-immortal-episode-i/2108775495884888/",
			name: "Vader Immortal",
			released: new Date("2019-05-21 10:00:00Z"),
			timeline: -1.2,
			type: Type.game,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Vader_Immortal:_A_Star_Wars_VR_Series_%E2%80%93_Episode_I",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.meta.com/experiences/star-wars-tales-from-the-galaxys-edge/3484270071659289/",
			name: "Tales from the Galaxy's Edge",
			released: new Date("2020-11-19 10:00:00Z"),
			timeline: 34.6,
			type: Type.game,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Tales_from_the_Galaxy%27s_Edge",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.meta.com/experiences/star-wars-beyond-victory/9460903453969753/",
			name: "Beyond Victory",
			released: new Date("2025-10-07 10:00:00Z"),
			timeline: -10.1,
			type: Type.game,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Star_Wars:_Beyond_Victory_-_A_Mixed_Reality_Playset",
		},
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.xbox.com/en-us/games/store/star-wars-zero-company/9ppt228dzk4n",
			name: "Zero Company",
			released: null,
			timeline: 20,
			type: Type.game,
			wookieepedia: "https://starwars.fandom.com/wiki/Star_Wars_Zero_Company",
		},
	]

	const highRepublic: Entry[] = [
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Convergence",
			released: new Date("2022-11-22 10:00:00Z"),
			timeline: -382.9,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Convergence",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Quest for the Hidden City",
			released: new Date("2022-11-01 10:00:00Z"),
			timeline: -382.8,
			type: Type.juniorReader,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Quest_for_the_Hidden_City",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Path of Deceit",
			released: new Date("2022-10-04 10:00:00Z"),
			timeline: -382.7,
			type: Type.youngAdultNovel,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Path_of_Deceit",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "The Battle of Jedha",
			released: new Date("2023-01-04 10:01:00Z"),
			timeline: -382.6,
			type: Type.audioDrama,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_The_Battle_of_Jedha",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Path of Vengeance",
			released: new Date("2023-05-02 10:00:00Z"),
			timeline: -382.5,
			type: Type.youngAdultNovel,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Path_of_Vengeance",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Cataclysm",
			released: new Date("2023-04-04 10:00:00Z"),
			timeline: -382.66,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Cataclysm",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Quest for Planet X",
			released: new Date("2023-04-04 10:01:00Z"),
			timeline: -382.3,
			type: Type.juniorReader,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Quest_for_Planet_X",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Into the Dark",
			released: new Date("2021-02-02 10:00:00Z"),
			timeline: -232.9,
			type: Type.youngAdultNovel,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Into_the_Dark",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Light of the Jedi",
			released: new Date("2021-01-05 10:00:00Z"),
			timeline: -232.99,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Light_of_the_Jedi",
		},
		{
			era: Era.highRepublic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-The-High-Republic-A-Test-of-Courage-Audiobook/0593291034",
			name: "A Test of Courage",
			released: new Date("2021-01-05 10:01:00Z"), // here
			timeline: -232.7,
			type: Type.juniorReader,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_A_Test_of_Courage",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "The Rising Storm",
			released: new Date("2021-06-29 10:00:00Z"),
			timeline: -231.9,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_The_Rising_Storm",
		},
		{
			era: Era.highRepublic,
			mediaLink:
				"https://www.audible.com/pd/Race-to-Crashpoint-Tower-Audiobook/1368075339",
			name: "Race to Crashpoint Tower",
			released: new Date("2021-06-29 10:01:00Z"),
			timeline: -231.8,
			type: Type.juniorReader,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Race_to_Crashpoint_Tower",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Out of the Shadows",
			released: new Date("2021-07-27 10:00:00Z"),
			timeline: -231.7,
			type: Type.youngAdultNovel,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Out_of_the_Shadows",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Tempest Runner",
			released: new Date("2021-08-31 10:00:00Z"),
			timeline: -231.6,
			type: Type.audioDrama,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Tempest_Runner",
		},
		{
			era: Era.highRepublic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-The-High-Republic-Mission-to-Disaster-Audiobook/B09NXFZBRJ",
			name: "Mission to Disaster",
			released: new Date("2022-01-03 10:00:00Z"),
			timeline: -230.9,
			type: Type.juniorReader,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Mission_to_Disaster",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Midnight Horizon",
			released: new Date("2022-02-01 10:00:00Z"),
			timeline: -230.8,
			type: Type.youngAdultNovel,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_Midnight_Horizon",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "The Fallen Star",
			released: new Date("2022-01-04 10:00:00Z"),
			timeline: -230.88,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_The_Fallen_Star",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "The Eye of Darkness",
			released: new Date("2023-11-14 10:00:00Z"),
			timeline: -229.9,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_High_Republic:_The_Eye_of_Darkness",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Escape from Valo",
			released: new Date("2024-01-30 10:00:00Z"),
			timeline: -228.999,
			type: Type.juniorReader,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Defy The Storm",
			released: new Date("2024-03-05 10:00:00Z"),
			timeline: -228.99,
			type: Type.youngAdultNovel,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Temptation of the Force",
			released: new Date("2024-06-11 10:00:00Z"),
			timeline: -228.9,
			type: Type.book,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Tears of the Nameless",
			released: new Date("2024-09-24 10:00:00Z"),
			timeline: -228.8,
			type: Type.youngAdultNovel,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Beware The Nameless",
			released: new Date("2024-08-27 10:00:00Z"),
			timeline: -228.7777,
			type: Type.juniorReader,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Seeds of Starlight",
			released: new Date("2024-11-14 10:00:00Z"),
			timeline: -228.777,
			type: Type.audioDrama,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Haunted Starlight",
			released: new Date("2025-03-06 10:00:00Z"),
			timeline: -228.77,
			type: Type.audioDrama,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Tempest Breaker",
			released: new Date("2025-05-13 10:00:00Z"),
			timeline: -228.7,
			type: Type.audioDrama,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Into the Light",
			released: new Date("2025-04-01 10:00:00Z"),
			timeline: -228.66,
			type: Type.youngAdultNovel,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "A Valiant Vow",
			released: new Date("2025-05-06 10:00:00Z"),
			timeline: -228.6,
			type: Type.juniorReader,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Trials of the Jedi",
			released: new Date("2025-06-16 10:00:00Z"),
			timeline: -228.5,
			type: Type.book,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "Wayseeker",
			released: new Date("2025-05-06 10:00:00Z"),
			timeline: -152.9,
			type: Type.book,
			wookieepedia: "",
		},
		{
			era: Era.highRepublic,
			mediaLink: "",
			name: "The Crystal Crown",
			released: new Date("2025-06-29 10:00:00Z"),
			timeline: -136,
			type: Type.youngAdultNovel,
			wookieepedia: "",
		},
	]

	const novels: Entry[] = [
		{
			era: Era.republic,
			mediaLink: "",
			name: "Padawan",
			released: new Date("2022-07-26 10:00:00Z"),
			timeline: -41,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Padawan_(novel)",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Master-Apprentice-Star-Wars-Audiobook/B07FTDBKGZ",
			name: "Master & Apprentice",
			released: new Date("2019-04-16 10:00:00Z"),
			timeline: -40,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Master_%26_Apprentice",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Queens-Peril-Audiobook/0593207696",
			name: "Queen's Peril",
			released: new Date("2020-06-02 10:00:00Z"),
			timeline: -32.1,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Queen%27s_Peril",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Queens-Shadow-Audiobook/B07M8YJFCH",
			name: "Queen's Shadow",
			released: new Date("2019-03-05 10:00:00Z"),
			timeline: -28,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Queen%27s_Shadow",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Dooku-Jedi-Lost-Star-Wars-Audiobook/0593102819",
			name: "Dooku: Jedi Lost",
			released: new Date("2019-10-01 10:00:00Z"),
			timeline: -23,
			type: Type.audioDrama,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Dooku:_Jedi_Lost_(script)",
		},
		{
			era: Era.republic,
			mediaLink: "https://www.audible.com/pd/Queens-Hope-Audiobook/B09VQQ3P6Z",
			name: "Queen's Hope",
			released: new Date("2022-01-25 10:00:00Z"),
			timeline: -22.8,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Queen%27s_Hope",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Brotherhood-Audiobook/B09HR33QHH",
			name: "Brotherhood",
			released: new Date("2022-05-10 10:00:00Z"),
			timeline: -22.6,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Brotherhood",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Catalyst-Star-Wars-Audiobook/B01J6GNS9I",
			name: "Catalyst",
			released: new Date("2016-11-15 10:00:00Z"),
			timeline: -21,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Catalyst:_A_Rogue_One_Novel",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Thrawn-Ascendancy-Audiobook/0593215389",
			name: "Thrawn Ascendancy: Chaos Rising",
			released: new Date("2020-09-01 10:00:00Z"),
			timeline: -19.9,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Thrawn_Ascendancy:_Chaos_Rising",
		},
		{
			era: Era.republic,
			mediaLink:
				"https://www.audible.com/pd/Dark-Disciple-Star-Wars-Audiobook/B00ZAURNZA",
			name: "Dark Disciple",
			released: new Date("2015-07-07 10:00:00Z"),
			timeline: -19.8,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Dark_Disciple",
		},
		{
			era: Era.empire,
			mediaLink: "",
			name: "Inquisitor: Rise of the Red Blade",
			released: new Date("2023-07-18 10:00:00Z"),
			timeline: -19.1, // TODO: confirm once released
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Inquisitor:_Rise_of_the_Red_Blade",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Thrawn-Ascendancy-Book-II-Greater-Good-Audiobook/059339688X",
			name: "Thrawn Ascendancy: Greater Good",
			released: new Date("2021-04-27 10:00:00Z"),
			timeline: -18.9,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Thrawn_Ascendancy:_Greater_Good",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Thrawn-Ascendancy-Book-III-Lesser-Evil-Audiobook/0593460618",
			name: "Thrawn Ascendancy: Lesser Evil",
			released: new Date("2021-11-16 10:00:00Z"),
			timeline: -18.8,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Thrawn_Ascendancy:_Lesser_Evil",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Ahsoka-Audiobook/B01M0YKIZA",
			name: "Ahsoka (Book)",
			released: new Date("2017-10-03 10:00:00Z"),
			timeline: -18.7,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Ahsoka_(novel)",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Thrawn-Star-Wars-Audiobook/B01MTYYPKY",
			name: "Thrawn",
			released: new Date("2017-04-11 10:00:00Z"),
			timeline: -15,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Thrawn_(novel)",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Lords-of-the-Sith-Star-Wars-Audiobook/B00VQO3GPU",
			name: "Lords of the Sith",
			released: new Date("2015-04-28 10:00:00Z"),
			timeline: -14.9,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Lords_of_the_Sith",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Tarkin-Star-Wars-Audiobook/B00O4IDJDE",
			name: "Tarkin",
			released: new Date("2014-11-04 10:00:00Z"),
			timeline: -14.8,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Tarkin_(novel)",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Most-Wanted-Audiobook/B07BL4DSD6",
			name: "Most Wanted",
			released: new Date("2018-05-25 10:01:00Z"),
			timeline: -13.9,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Most_Wanted",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Rebel-Rising-Audiobook/B06XT8G4NB",
			name: "Rebel Rising",
			released: new Date("2017-05-02 10:00:00Z"),
			timeline: -13.8,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Rebel_Rising",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/A-New-Dawn-Star-Wars-Audiobook/B00M0OZZTK",
			name: "A New Dawn",
			released: new Date("2014-09-02 10:00:00Z"),
			timeline: -11,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/A_New_Dawn_(novel)",
		},
		{
			era: Era.empire,
			mediaLink: "",
			name: "Jedi: Battle Scars",
			released: new Date("2023-03-07 10:00:00Z"),
			timeline: -9.4, // TODO: confirm once released
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Jedi:_Battle_Scars",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.amazon.com/Journey-Star-Wars-Force-Awakens-ebook/dp/B00YB2HK42/ref=tmm_kin_swatch_0",
			name: "Lost Stars",
			released: new Date("2015-09-04 10:01:00Z"),
			timeline: -6,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Lost_Stars",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Journey-to-Star-Wars-The-Last-Jedi-Leia-Princess-of-Alderaan-Audiobook/B074CMXKJ4",
			name: "Leia, Princess of Alderaan",
			released: new Date("2017-09-01 10:01:00Z"),
			timeline: -3,
			type: Type.youngAdultNovel,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Leia,_Princess_of_Alderaan",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Thrawn-Alliances-Star-Wars-Audiobook/B077Y7PLS4",
			name: "Thrawn: Alliances",
			released: new Date("2018-07-24 10:00:00Z"),
			timeline: -2,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Thrawn:_Alliances",
		},
		{
			era: Era.empire,
			mediaLink:
				"https://www.audible.com/pd/Thrawn-Treason-Audiobook/1984889966",
			name: "Thrawn: Treason",
			released: new Date("2019-07-23 10:00:00Z"),
			timeline: -0.9,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Thrawn:_Treason",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Heir-to-the-Jedi-Star-Wars-Audiobook/B00RDN6628",
			name: "Heir to the Jedi",
			released: new Date("2015-03-03 10:00:00Z"),
			timeline: 0.5,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Heir_to_the_Jedi",
		},
		{
			era: Era.rebellion,
			mediaLink: "",
			name: "The Princess and the Scoundrel",
			released: new Date("2022-08-16 10:00:00Z"),
			timeline: 4.1,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/The_Princess_and_the_Scoundrel",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Alphabet-Squadron-Star-Wars-Audiobook/1984889931",
			name: "Alphabet Squadron",
			released: new Date("2019-06-11 10:00:00Z"),
			timeline: 4.4,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Alphabet_Squadron_(novel)",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Aftermath-Star-Wars-Audiobook/B011PVXPO0",
			name: "Aftermath",
			released: new Date("2015-09-04 10:00:00Z"),
			timeline: 4.6,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Aftermath_(novel)",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Shadow-Fall-Star-Wars-Audiobook/0593215354",
			name: "Shadow Fall",
			released: new Date("2020-06-23 10:00:00Z"),
			timeline: 5,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Shadow_Fall",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Life-Debt-Aftermath-Book-2-Audiobook/B01CRN2KBY",
			name: "Life Debt",
			released: new Date("2016-07-12 10:00:00Z"),
			timeline: 5.1,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Aftermath:_Life_Debt",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Victorys-Price-Star-Wars-Audiobook/0593396855",
			name: "Victory's Price",
			released: new Date("2021-03-02 10:00:00Z"),
			timeline: 5.3,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Victory%27s_Price",
		},
		{
			era: Era.rebellion,
			mediaLink:
				"https://www.audible.com/pd/Empires-End-Aftermath-Audiobook/B01MRSYSI4",
			name: "Empires End",
			released: new Date("2017-02-21 10:00:00Z"),
			timeline: 5.4,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Aftermath:_Empire%27s_End",
		},
		{
			era: Era.newRepublic,
			mediaLink: "",
			name: "Last Shot",
			released: new Date("2018-04-17 10:00:00Z"),
			timeline: 7,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Last_Shot",
		},
		{
			era: Era.newRepublic,
			mediaLink: "",
			name: "Poe Dameron: Free Fall",
			released: new Date("2020-08-04 10:00:00Z"),
			timeline: 18,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Poe_Dameron:_Free_Fall",
		},
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Shadow-of-the-Sith-Audiobook/B09HR24RRV",
			name: "Shadow of the Sith",
			released: new Date("2022-06-28 10:00:00Z"),
			timeline: 21,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Shadow_of_the_Sith",
		},
		{
			era: Era.newRepublic,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Bloodline-New-Republic-Audiobook/B01CRMO9BE",
			name: "Bloodline",
			released: new Date("2016-05-03 10:00:00Z"),
			timeline: 28,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Bloodline_(novel)",
		},
		{
			era: Era.newRepublic,
			mediaLink: "",
			name: "Force Collector",
			released: new Date("2019-10-04 10:00:00Z"),
			timeline: 31,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/Force_Collector",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.audible.com/pd/Phasma-Star-Wars-Audiobook/B074CMPKG3",
			name: "Phasma",
			released: new Date("2017-09-01 10:00:00Z"),
			timeline: 34.05,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Phasma_(novel)",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.audible.com/pd/Galaxys-Edge-Black-Spire-Star-Wars-Audiobook/0593150511",
			name: "Black Spire",
			released: new Date("2019-08-27 10:00:00Z"),
			timeline: 34.4,
			type: Type.book,
			wookieepedia:
				"https://starwars.fandom.com/wiki/Galaxy%27s_Edge:_Black_Spire",
		},
		{
			era: Era.firstOrder,
			mediaLink: "",
			name: "Resistance Reborn",
			released: new Date("2019-11-05 10:00:00Z"),
			timeline: 34.5,
			type: Type.book,
			wookieepedia: "https://starwars.fandom.com/wiki/Resistance_Reborn",
		},
		{
			era: Era.firstOrder,
			mediaLink:
				"https://www.audible.com/pd/Star-Wars-Galaxys-Edge-A-Crash-of-Fate-Audiobook/0593152603",
			name: "A Crash of Fate",
			released: new Date("2019-08-06 10:00:00Z"),
			timeline: 34.55,
			type: Type.youngAdultNovel,
			wookieepedia: "https://starwars.fandom.com/wiki/A_Crash_of_Fate",
		},
	]

	export const Entries: Entry[] = [
		...skywalkerSaga,
		...otherFilms,
		...shows,
		...games,
		...highRepublic,
		...novels,
	]
}
